import { useJsApiLoader } from "@react-google-maps/api";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import AppointmentButton from '../appointments/AppointmentButton';
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import {
  setProfileData as setProfileDataAction,
  setBusinessData as setBusinessDataAction,
} from "../../store/providerProfileSlice";

import { Rating } from 'primereact/rating';        
import config from "../../config";
import {
  getServiceProviderProfileView,
  getServiceProviderBusinessDetailsView,
  uploadImage,
  updateServiceProviderProfile,
  updateServiceProviderBusiness,
} from "../../Apiservices/Auth/servers/profileServer";
import {addServiceProviderAddressInfo,editServiceProviderAddressInfo} from "../../Apiservices/Auth/servers/updateServiceProviderProfile.js"
import "./profile.css";
import StripePayoutSetup from "./StripePayoutSetup";
import ProviderDocumentsSection from './ProviderDocumentsSection';

const ManageProfileTabContent = () => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_API_KEY || 'AIzaSyCfBZYkyctvp5zTzY-Rb1dfTYGW6TWSp7U';

const { isLoaded } = useJsApiLoader({
  googleMapsApiKey,
  libraries: ["places", "maps"],  // Add required libs if needed
}); 
  
  const { id } = useParams();
  const publicprofile = id? true:false;
  const toast = useRef(null);
  const [profileData, setProfileData] = useState(null);
  const [editableProfileData, setEditableProfileData] = useState(null);
  const [updatedFields, setUpdatedFields] = useState({});
  const [editableBusinessData, setEditableBusinessData] = useState(null);
  const [updatedBusinessFields, setUpdatedBusinessFields] = useState({});
  const [isAnyChanges, setIsAnyChanges] = useState(false);
  const [businessData, setBusinessData] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const dispatch = useDispatch();
  // Add after other state declarations
const [verificationData, setVerificationData] = useState({
  gstNumber: "",
  gstDocument: null,
  kycVerified: profileData?.isKycVerified || false,
  gstVerified: profileData?.isGstVerified || false
});
  const { profile: reduxProfileData, business: reduxBusinessData } =
    useSelector((state) => state.providerProfile);
console.log(" profile:"," reduxProfileData,",reduxProfileData ,"business: reduxBusinessData ",reduxBusinessData)
  const isServiceDescriptionEnabled = false;

  const [location, setLocation] = useState({ lat: 0, lng: 0 });
   const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
const fetchAddress = (lat, lng) => {
  if (isLoaded) {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const result = results[0];
        const addressComponents = result.address_components;
        const getComponent = (type) =>
          addressComponents.find((comp) => comp.types.includes(type))
            ?.long_name || "";

        const updatedAddress = {
          ...editableProfileData.addresses?.[0],
          formattedAddress: result.formatted_address,
          locality: getComponent("sublocality") || getComponent("locality"),
          city: getComponent("locality"),
          state: getComponent("administrative_area_level_1"),
          country: getComponent("country"),
          latitude: lat,
          longitude: lng,
        };
        

        // Update the editableProfileData state
       setEditableProfileData((prev) => {
          const updatedData = {
            ...prev,
            addresses: [updatedAddress],
          };
          console.log("✏️ Updating editableProfileData to fetchaddress:", updatedData);
          return updatedData;
        });
        // Track updates
        setUpdatedFields((prev) => {
          const updated = { ...prev };

          const original = profileData.addresses?.[0] || {};
          for (const key in updatedAddress) {
            const fieldKey = `addresses.0.${key}`;
            if (updatedAddress[key] !== original[key]) {
              updated[fieldKey] = updatedAddress[key];
            } else {
              delete updated[fieldKey];
            }
          }
           
          checkIfAnyChanges(updated, updatedBusinessFields);
          return updated;
        });
      } else {
        console.error("Geocoder failed due to:", status);
      }
    });
  }
};

    const getcurrentlocation = () =>{
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ lat: latitude, lng: longitude });
          fetchAddress(latitude, longitude);
        },
        (error) => {
          console.error("Error fetching location:", error);
          alert("Unable to fetch location. Please enable location services.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }

  }
  const fetchProviderDetails = async () => {
    try {
      const profileRes = await getServiceProviderProfileView(id);
      const businessRes = await getServiceProviderBusinessDetailsView(id);
      console.log("providerid",id,profileRes,businessRes)
      setProfileData(profileRes);
      console.log("datais",profileRes)
      setBusinessData(businessRes);
      console.log("businessRes",businessRes)
    } catch (error) {
      console.error("Failed to fetch provider data:", error);
    }
  };
  const pickFile = () => {
    return new Promise((resolve, reject) => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (event) => {
        const file = event.target.files[0];
        if (file) resolve(file);
        else reject(new Error("No file selected"));
      };
      input.click();
    });
  };
  const handleUploadUpiImage = async () => {
    try {
      const file = await pickFile();
      const id = await uploadImage(file);
      setEditableBusinessData((prev) => ({
        ...prev,
        upi_image_id: id,
      }));
      setIsAnyChanges(true);
    } catch (error) {
      console.error("Failed to upload UPI image:", error);
    }
  };

  const handleUploadGalleryImage = async () => {
    try {
      const file = await pickFile();
      const id = await uploadImage(file);
      setEditableBusinessData((prev) => ({
        ...prev,
        gallery_image_ids: [...prev.gallery_image_ids, id],
      }));
      setIsAnyChanges(true);
    } catch (error) {
      console.error("Failed to upload Gallery image:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchProviderDetails();
    } else {
      setProfileData(reduxProfileData);
      console.log("reduxProfileData",reduxProfileData)
      setBusinessData(reduxBusinessData);
      console.log("reduxBusinessData",reduxBusinessData)
       setVerificationData({
      gstNumber: "",
      gstDocument: null,
      kycVerified: reduxProfileData?.isKycVerified || false,
      gstVerified: reduxProfileData?.isGstVerified || false,
      gstSubmitted: false // Add this flag to track submission
    });
    }
  }, [id, reduxProfileData, reduxBusinessData]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.current?.show({
      severity: "success",
      summary: "Copied",
      detail: "UPI ID copied to clipboard",
      life: 2000,
    });
  };
  const handleEditClick = () => {
    setIsEditing(true);
     const editableData = {
    firstName: profileData.firstName || "",
    lastName: profileData.lastName || "",
    mobileNumber: profileData.mobileNumber || "",
    emailId: profileData.emailId || "",
    addresses: profileData.addresses || [],  // ⚠️ fix: was `address`
  };
  
  console.log("🛠️ Setting editableProfileData to handleclick edit:", editableData); 
    setEditableProfileData({
      firstName: profileData.firstName || "",
      lastName: profileData.lastName || "",
      mobileNumber: profileData.mobileNumber || "",
      emailId: profileData.emailId || "",
      addresses : profileData.addresses || "",
    });    
    setEditableBusinessData({
      business_name: businessData.business_name || "",
      short_description: businessData.short_description || "",
      long_description: businessData.long_description || "",
      upi_id: businessData.upi_id || "",
      upi_image_id: businessData.upi_image_id || null, // ✅ add
      gallery_image_ids: businessData.galleryImages?.map((img) => img.id) || [], // ✅ add
    });
      setVerificationData({
    gstNumber: "",
    gstDocument: null,
    kycVerified: profileData?.isKycVerified || false,
    gstVerified: profileData?.isGstVerified || false,
    gstSubmitted: false
  });
    setUpdatedFields({});
    setUpdatedBusinessFields({});
    setIsAnyChanges(false);
  };

  const checkIfAnyChanges = (updatedProfile, updatedBusiness) => {
    setIsAnyChanges(
      (updatedProfile && Object.keys(updatedProfile).length > 0) ||
        (updatedBusiness && Object.keys(updatedBusiness).length > 0)
    );
  };
  const handleProfileInputChange = (e) => {

    const { name, value } = e.target;

    setEditableProfileData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setUpdatedFields((prev) => {
      const updated = { ...prev };

      if (value !== profileData[name]) {
        updated[name] = value;
      } else {
        delete updated[name];
      }

      checkIfAnyChanges(updated, updatedBusinessFields);
      return updated;
    });
  };
  const handleAddressInputChange = (e) => {
  const { name, value } = e.target;

  setEditableProfileData((prev) => {
    // Clone addresses array
    const addresses = [...(prev.addresses || [])];
    if (addresses.length === 0) {
      addresses.push({
        streetNumber: '',
        street: '',
        locality: '',
        pincode: '',
        city: '',
        state: '',
        country: '',
        latitude: 0,
        longitude: 0,
        formattedAddress: '',
        optionalNotes: '',
        
      });
    }

    // Update only the first address (index 0)
    addresses[0] = {
      ...addresses[0],
      [name]: value,
    };
    const updatedProfile = { ...prev, addresses };

    // 🔍 Log the full updated editableProfileData
    console.log("📝 Updated editableProfileData:", updatedProfile);
    return { ...prev, addresses };
  });

  setUpdatedFields((prev) => {
    const updated = { ...prev };
    checkIfAnyChanges(updated, updatedBusinessFields);
    return updated;
  });
};

  const handleBusinessInputChange = (e) => {
    const { name, value } = e.target;

    const originalValue = businessData?.[name] || "";

    setEditableBusinessData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setUpdatedBusinessFields((prev) => {
      const updated = { ...prev };

      if (value !== originalValue) {
        updated[name] = value;
          console.log(`Field updated: ${name} = ${value}`);
      } else {
        delete updated[name];
          console.log(`Field reverted to original, removing: ${name}`);
      }

      checkIfAnyChanges(updatedFields, updated);
      return updated;
    });
  };
  
  const extractPincode = (addr) => {
  const match = addr.match(/\b\d{5,6}\b/);
  return match ? match[0] : "";
};
console.log({finalcheck:profileData})
const handleSaveChanges = async () => {
  console.log({ finalcheck333: profileData });

  if (!isAnyChanges) {
    toast.current?.show({
      severity: "info",
      summary: "No Changes",
      detail: "No fields were changed.",
      life: 2000,
    });
    setIsEditing(false);
    return;
  }

  try {
    // ----- 1️⃣ Build Business Update Payload -----
 let finalBusinessUpdate = {
  ...updatedBusinessFields,
  ...(editableBusinessData.upi_image_id
    ? { upi_image_id: editableBusinessData.upi_image_id }
    : {}),
  ...(editableBusinessData.gallery_image_ids?.length
    ? { gallery_image_ids: editableBusinessData.gallery_image_ids }
    : {}),
};

// ✅ Only add business_name if there’s already something else to update
if (Object.keys(finalBusinessUpdate).length > 0 &&
    !updatedBusinessFields.hasOwnProperty("business_name")) {
  finalBusinessUpdate.business_name = businessData.business_name;
}

    console.log("finalBusinessUpdate",finalBusinessUpdate)
    // ----- 2️⃣ Build Profile Update Payload (exclude address fields) -----
    const profileFieldsToUpdate = Object.keys(updatedFields).reduce((acc, key) => {
      if (!key.startsWith("addresses.")) {
        acc[key] = updatedFields[key];
      }
      return acc;
    }, {});
if ("min_guest_count" in profileFieldsToUpdate &&
    !profileFieldsToUpdate.hasOwnProperty("firstName")) {
  profileFieldsToUpdate.firstName = profileData.firstName;
}
    // // If business_name not in updated fields, retain the old one
//    if ("min_guest_count" in profileFieldsToUpdate && 
//     !profileFieldsToUpdate.hasOwnProperty("business_name")) {
//   profileFieldsToUpdate.business_name = businessData.business_name;
// }

    // ----- 3️⃣ Get Address Data -----
    console.log("editableProfileData",editableProfileData)
    
    console.log("profileFieldsToUpdate",profileFieldsToUpdate)
    // ----- 4️⃣ Determine which APIs to call -----
    const shouldUpdateProfile = Object.keys(profileFieldsToUpdate).length > 0;
    const shouldUpdateBusiness =
      Object.keys(finalBusinessUpdate).length > 0 &&
      (
        Object.keys(updatedBusinessFields).length > 0 ||
        editableBusinessData.upi_image_id !== businessData.upi_image_id ||
        JSON.stringify(editableBusinessData.gallery_image_ids) !==
          JSON.stringify(businessData.galleryImages?.map(img => img.id) || [])
      );
    const fullAddressObj = editableProfileData?.addresses?.[0] || {};
const hasAddressChanged =
  JSON.stringify(fullAddressObj) !== JSON.stringify(profileData?.addresses?.[0] || {});
const shouldUpdateAddress = hasAddressChanged && Boolean(fullAddressObj);


    console.log("🔍 API Call Flags", {
      shouldUpdateProfile,
      shouldUpdateBusiness,
      shouldUpdateAddress
    });

    // ----- 5️⃣ Call APIs in order -----
    // Address
    if (shouldUpdateAddress) {
      if (fullAddressObj.id) {
        console.log("🏠 Updating existing address:", fullAddressObj);
        await editServiceProviderAddressInfo(fullAddressObj, fullAddressObj.id);
      } else {
        console.log("➕ Adding new address:", fullAddressObj);
        await addServiceProviderAddressInfo(fullAddressObj);
      }
    }

    // Profile
    if (shouldUpdateProfile) {
      await updateServiceProviderProfile(profileData?.providerTypes?.[0]?.id, profileFieldsToUpdate);
    }

    // Business
    if (shouldUpdateBusiness) {
      await updateServiceProviderBusiness(id, finalBusinessUpdate, businessData.business_name);
    }

    // ----- 6️⃣ Update Local State -----
    if (id) {
      await fetchProviderDetails();
    } else {
      if (shouldUpdateProfile) {
        dispatch(setProfileDataAction({ ...profileData, ...updatedFields }));
      }
      if (shouldUpdateBusiness) {
        dispatch(setBusinessDataAction({ ...businessData, ...finalBusinessUpdate }));
      }
    }

    // Reset
    setIsEditing(false);
    setUpdatedFields({});
    setUpdatedBusinessFields({});
    setIsAnyChanges(false);

    toast.current?.show({
      severity: "success",
      summary: "Success",
      detail: "Profile, Business and Address info updated successfully",
      life: 2000,
    });
  } catch (error) {
    console.error("❌ Failed to save changes:", error);
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "Failed to update profile/business/address info",
      life: 3000,
    });
  }
};


const handleShare = () => {
  console.log("editableProfileData",profileData)
  const url = `https://thurent.com/service-provider/info/${profileData.id}`;

  if (navigator.share) {
    navigator.share({
      title: 'Check this out!',
      text: 'Here is the profile I wanted to share.',
      url: url,
    }).catch((error) => console.error('Error sharing:', error));
  } else {
    // Fallback: Copy to clipboard
    navigator.clipboard.writeText(url);
    alert('Link copied to clipboard');
  }
};

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditableProfileData(null);
    setEditableBusinessData(null);
    setUpdatedFields({});
    setUpdatedBusinessFields({});
    setIsAnyChanges(false);
  };

  if (!profileData || !businessData) return <p>Loading...</p>;

  const hasUPI = businessData?.upi_id || businessData?.upi_image_id;
  const hasGalleryImages = businessData?.galleryImages?.length > 0;

  const initials = profileData.firstName?.[0]?.toUpperCase() || "?";
    
const images = isEditing
  ? (editableBusinessData?.gallery_image_ids || [])
  : (businessData?.galleryImages?.map((img) => img.id) || []);

  return (
    <div className="profile-wrapper">
      {publicprofile ? <AppointmentButton providerId={id} providerName={[profileData?.firstName, profileData?.lastName].filter(Boolean).join(' ')} source="provider-profile" /> : <Link to="/service-provider/calendar">Calendar</Link>}
      {!publicprofile && <StripePayoutSetup />}
      {!publicprofile && profileData && <ProviderDocumentsSection profile={profileData} onUpdated={(fields) => setProfileData(current => ({ ...current, ...fields }))} />}
      <div className="profile-header-actions">
        
        {!id &&
          (!isEditing ? (
            
            <Button
              label="Edit"
              icon="pi pi-pencil"
              onClick={handleEditClick}
              className="p-button-sm p-button-outlined edit-action-btn"
            />
          ) : (
            <div className="edit-action-buttons">
              <Button
                label="Save Changes"
                icon="pi pi-save"
                onClick={handleSaveChanges}
                className="p-button-sm p-button-success edit-action-btn"
                disabled={!isAnyChanges}
              />
              <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={handleCancelEdit}
                className="p-button-sm p-button-secondary edit-action-btn"
              />
            </div>
          ))}
      </div>
      {/* Profile Header */}
      <div className="profile-header">
        <div className="profile-avatar">
          {profileData.profilePicUrl ? (
            <img
              src={profileData.profilePicUrl}
              alt="Profile"
              onError={(e) => (e.target.style.display = "none")}
            />
          ) : (
            <Avatar              
              icon="pi pi-user"               
              shape="circle"        
              className="avatar"
            />
          )}
        </div>
        <div className={`profile-info`}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h2 className="provider-headder">
              {isEditing ? (
                <>
                  <input
                    type="text"
                    name="firstName"
                    value={editableProfileData.firstName}
                    onChange={handleProfileInputChange}
                    placeholder="First Name"
                    className="edit-input"
                  />{" "}
                  <input
                    type="text"
                    name="lastName"
                    value={editableProfileData.lastName}
                    onChange={handleProfileInputChange}
                    placeholder="Last Name"
                    className="edit-input"
                  />
                </>
              ) : (
                `${profileData.firstName} ${profileData.lastName}`
              )}
            </h2>
          </div>
          <div>
              <Rating value={4.3} disabled cancel={false} />
          </div>
          <div>
            <Button icon="pi pi-share-alt" label="Share"   className="share-button" onClick={handleShare}/>
          </div>
       {/* data that need to add at bottom */}
          {/* <p>
            <strong>Phone:</strong>{" "}
            {isEditing ? (
              <input
                type="text"
                name="mobileNumber"
                value={editableProfileData.mobileNumber}
                onChange={handleProfileInputChange}
                placeholder="Mobile Number"
                className="edit-input"
              />
            ) : (
              profileData.mobileNumber
            )}
          </p> */}
          {/* email data */}
          {/* <p>
            <strong>Email:</strong>{" "}
            {isEditing ? (
              <input
                type="email"
                name="emailId"
                value={editableProfileData.emailId}
                onChange={handleProfileInputChange}
                placeholder="Email"
                className="edit-input"
              />
            ) : (
              <span>
              {profileData.emailId} [
              <span style={{ color: profileData.isEmailIdVerified ? "inherit" : "red" }}>
                {profileData.isEmailIdVerified ? "Verified" : "Unverified"}
              </span>
              ]
            </span>

            )}
          </p> */}
          {/* address data */}

      {/* <p>
  <strong>Address:</strong>{" "}
  {isEditing ? (
    <>
      <input
        type="text"
        name="formattedAddress"
        value={editableProfileData.addresses?.[0]?.formattedAddress || ""}
        onChange={handleAddressInputChange}
        placeholder="Formatted Address"
        className="edit-input"
      />
      <button onClick={getcurrentlocation} style={{ marginLeft: "8px" }}>
        Current Location
      </button>
    </>
  ) : (
    profileData.addresses?.[0]?.formattedAddress || "No address available"
  )}
</p> */}



{/* {profileData?.providerTypes?.[0]?.id === 9 && (
  <p>
    <strong>Minimum number of people: </strong>
    {isEditing ? (
      <input
        type="number"
        name="min_guest_count"
        value={editableProfileData.min_guest_count ?? ""}
        onChange={handleProfileInputChange}
        style={{ marginLeft: "8px", width: "60px" }}
      />
    ) : (
      <span style={{ marginLeft: "8px" }}>
        {profileData.min_guest_count ?? "Not specified"}
      </span>
    )}
  </p>
)} */}
{/* data */}

        </div>
      </div>
      <div className="business-container">
         
         <div className="business-info">
      {/* Business Information */}
      <div className="profile-section">
        <h3 className="business-headder">Business Information </h3>
        <p className="subtext-business">
          <strong>Vendor Name:</strong>{" "}
          {isEditing ? (
            <input
              type="text"
              name="business_name"
              value={editableBusinessData.business_name}
              onChange={handleBusinessInputChange}
              className="edit-input"
              placeholder="Business Name"
            />
          ) : (
            businessData.business_name
          )}
        </p>
        <div>
        {profileData?.providerTypes?.[0]?.id === 9 && (
          <p className="subtext-business">
            <strong>Minimum Order Requriment: </strong>
            {isEditing ? (
              <input
                type="number"
                name="min_guest_count"
                value={ editableProfileData?.min_guest_count !== undefined
        ? editableProfileData.min_guest_count
        : profileData?.min_guest_count ?? ""}
                onChange={handleProfileInputChange}

              />
            ) : (
              <span>
                {profileData.min_guest_count ?? "Not specified"}
              </span>
            )}
          </p>
        )}
     </div>
        {/* <p>
          <strong>Short Description:</strong>{" "}
          {isEditing ? (
            <input
              type="text"
              name="short_description"
              value={editableBusinessData.short_description}
              onChange={handleBusinessInputChange}
              className="edit-input"
              placeholder="Short Description"
            />
          ) : (
            businessData.short_description
          )}
        </p> */}
        <p>
          <strong>Description:</strong>
          {isEditing ? (
            <textarea
              name="long_description"
              value={editableBusinessData.long_description}
              onChange={handleBusinessInputChange}
              className="edit-input"
              placeholder="Description"
              rows="4"
            />
          ) : (
            businessData.long_description
          )}
        </p>
             
      </div>
      {/* Services Section */}
      {/* <div className="profile-section">
        <h3>My Services</h3>
        {profileData.services.length === 0 ? (
          <Message severity="info" text="No services found." />
        ) : (
          <div className="services-chip-wrap">
            {profileData.services.map((service) => (
              <div key={service.id} className="service-chip">
                {service.serviceName}
                {isServiceDescriptionEnabled && (
                  <div className="service-description">
                    My Dummy Description
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div> */}
      </div>
        {/* UPI Section */}
        <div className="upi-container">
              {isEditing || hasUPI ? (
          <div className="upi-section">
            {isEditing ? (
              <>
                {/* Editable UPI Image */}
                {editableBusinessData.upi_image_id ? (
                  <div className="image-item">
                    <img
                      src={`${config.API_BASE_URL}/gallery/download/${editableBusinessData.upi_image_id}`}
                      alt="UPI QR"
                      className="upi-image"
                    />
                    <Button
                      icon="pi pi-times"
                      className="p-button-danger p-button-sm"
                      onClick={() => {
                        setEditableBusinessData((prev) => ({
                          ...prev,
                          upi_image_id: null,
                        }));
                        setIsAnyChanges(true);
                      }}
                    />
                  </div>
                ) : (
                  <Button
                    label="Add UPI Image"
                    icon="pi pi-plus"
                    className="p-button-sm"
                    onClick={handleUploadUpiImage}
                  />
                )}

                {/* Editable UPI ID */}
                <div className="upi-id-wrap" style={{ marginTop: "1rem" }}>
                  <input
                    type="text"
                    name="upi_id"
                    value={editableBusinessData.upi_id}
                    onChange={handleBusinessInputChange}
                    className="edit-input"
                    placeholder="UPI ID"
                  />
                  <Button
                    icon="pi pi-copy"
                    className="p-button-sm p-button-text"
                    onClick={() => copyToClipboard(editableBusinessData.upi_id)}
                  />
                </div>
              </>
            ) : (
              <>
                {businessData.upi_image_id && (
                  <>
                    <Tooltip target=".upi-image" content="Click to enlarge" />
                    <img
                      src={`${config.API_BASE_URL}/gallery/download/${businessData.upi_image_id}`}
                      alt="UPI QR"
                      className="upi-image"
                      onClick={() => setVisible(true)}
                    />
                    <Dialog
                      header="Scan UPI"
                      visible={visible}
                      style={{ width: "320px" }}
                      onHide={() => setVisible(false)}
                      footer={
                        <Button
                          label="OK"
                          onClick={() => setVisible(false)}
                          autoFocus
                        />
                      }
                      dismissableMask
                    >
                      <div style={{ textAlign: "center" }}>
                        <img
                          src={`${config.API_BASE_URL}/gallery/download/${businessData.upi_image_id}`}
                          alt="UPI Full"
                          className="upi-full-image"
                        />
                        {businessData.upi_id && (
                          <div
                            style={{
                              marginTop: "1rem",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "0.5rem",
                              flexWrap: "wrap",
                            }}
                          >
                            <strong>{businessData.upi_id}</strong>
                            <Button
                              icon="pi pi-copy"
                              className="p-button-sm p-button-secondary"
                              onClick={() =>
                                copyToClipboard(businessData.upi_id)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </Dialog>
                  </>
                )}
                {businessData.upi_id && (
                  <div className="upi-id-wrap">
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          name="upi_id"
                          value={editableBusinessData.upi_id}
                          onChange={handleBusinessInputChange}
                          className="edit-input"
                          placeholder="UPI ID"
                        />
                        <Button
                          icon="pi pi-copy"
                          className="p-button-sm p-button-text"
                          onClick={() =>
                            copyToClipboard(editableBusinessData.upi_id)
                          }
                        />
                      </>
                    ) : (
                      <>
                        <span>{businessData.upi_id}</span>
                        <Button
                          icon="pi pi-copy"
                          className="p-button-sm p-button-text"
                          onClick={() => copyToClipboard(businessData.upi_id)}
                        />
                      </>
                    )}
                  </div>
                )}
                <Toast ref={toast} />
              </>
            )}
          </div>
        ) : (
          <Message severity="warn" text="UPI information is not available." />
        )}
        </div>
      </div>
        <div className="gallery-section">
          <div className="gallery-images">
                  {/* Gallery Section */}
      <div className="profile-section">
        <h3>Gallery Images</h3>
        {isEditing || hasGalleryImages ? (
         <div className="gallery-wrapper">
  {/* Scroll Left Button */}
  {images.length > 4 && (
    <button
      className="gallery-btn left"
      onClick={() =>
        document.querySelector('.gallery-grid').scrollBy({ left: -200, behavior: 'smooth' })
      }
    >
      ◀
    </button>
  )}

  {/* Images */}
  <div className="gallery-grid">
    {images.map((id, idx) => (
      <div key={idx} className="image-item">
        <img
          src={`${config.API_BASE_URL}/gallery/download/${id}`}
          alt={`Gallery ${idx + 1}`}
          className="gallery-img"
        />
        {isEditing && (
          <Button
            icon="pi pi-times"
            className="p-button-danger p-button-sm"
            onClick={() => {
              setEditableBusinessData((prev) => ({
                ...prev,
                gallery_image_ids: prev.gallery_image_ids.filter((imgId) => imgId !== id),
              }));
              setIsAnyChanges(true);
            }}
          />
        )}
      </div>
    ))}

    {isEditing && editableBusinessData.gallery_image_ids.length < 4 && (
      <Button
        label="Add Image"
        icon="pi pi-plus"
        className="p-button-sm"
        onClick={handleUploadGalleryImage}
      />
    )}
  </div>

  {/* Scroll Right Button */}
  {images.length > 4 && (
    <button
      className="gallery-btn right"
      onClick={() =>
        document.querySelector('.gallery-grid').scrollBy({ left: 200, behavior: 'smooth' })
      }
    >
      ▶
    </button>
  )}
</div>
        ) : (
          <Message severity="warn" text="Gallery images are not available." />
        )}
      </div>
          </div>
        </div>
        <div className="vendor-info">
          <h3 className="business-headder">Vendor Information </h3>
          <div>
                    <p className="subtext-business">
            <strong>Contact:</strong>{" "}
            {isEditing ? (
              <input
                type="text"
                name="mobileNumber"
                value={editableProfileData.mobileNumber}
                onChange={handleProfileInputChange}
                placeholder="Mobile Number"
                className="edit-input"
              />
            ) : (
               publicprofile
    ? `****${profileData.mobileNumber?.slice(-4)}`
    : profileData.mobileNumber
            )
            }
          </p>
          </div>
          {/* email data */}
          <div>
          <p className="subtext-business">
            <strong>Email:</strong>{" "}
            {isEditing ? (
              <input
                type="email"
                name="emailId"
                value={editableProfileData.emailId}
                onChange={handleProfileInputChange}
                placeholder="Email"
                className="edit-input"
              />
            ) : (
              <span>
               {publicprofile
    ? profileData.emailId?.includes('@')
      ? `****@${profileData.emailId.split('@')[1]}`
      : "-"
    : profileData.emailId || "-"}[
              <span style={{ color: profileData.isEmailIdVerified ? "inherit" : "red" }}>
                {profileData.isEmailIdVerified ? "Verified" : "Unverified"}
              </span>
              ]
            </span>

            )}
          </p>
          </div>
          {/* address data */}
            <div>
              <p className="subtext-business">
               <strong>Address:</strong>{" "}
               {isEditing ? (
                 <>
                   <input
                     type="text"
                     name="formattedAddress"
                     value={editableProfileData.addresses?.[0]?.formattedAddress || ""}
                     onChange={handleAddressInputChange}
                     placeholder="Formatted Address"
                     className="edit-input"
                   />
                   <button onClick={getcurrentlocation} style={{ marginLeft: "8px" }}>
                     Current Location
                   </button>
                 </>
               ) : (
                 profileData.addresses?.[0]?.formattedAddress || "No address available"
               )}
              </p>
             </div>
{/* {profileData?.providerTypes?.[0]?.id === 9 && (
  <p>
    <strong>Minimum number of people: </strong>
    {isEditing ? (
      <input
        type="number"
        name="min_guest_count"
        value={editableProfileData.min_guest_count ?? ""}
        onChange={handleProfileInputChange}
        style={{ marginLeft: "8px", width: "60px" }}
      />
    ) : (
      <span style={{ marginLeft: "8px" }}>
        {profileData.min_guest_count ?? "Not specified"}
      </span>
    )}
  </p>
)} */}
        </div>
        

        <div className="verification-status">
  <div>
    <span className="headderof_verification">Verification Status</span>
    
    {/* Verification Flags */}
    <div className="verification-flags">
      <div className={`flag-item ${profileData?.isKycVerified ? 'verified' : 'pending'}`}>
        <i className={`pi ${profileData?.isKycVerified ? 'pi-check-circle' : 'pi-clock'}`}></i>
        <span>KYC {profileData?.isKycVerified ? 'Verified' : 'Pending'}</span>
      </div>
      <div className={`flag-item ${profileData?.isGstVerified ? 'verified' : 'pending'}`}>
        <i className={`pi ${profileData?.isGstVerified ? 'pi-check-circle' : 'pi-clock'}`}></i>
        <span>GST {profileData?.isGstVerified ? 'Verified' : 'Pending'}</span>
      </div>
    </div>

    {/* GST Input Section (only show when editing) */}
    {isEditing && !profileData?.isGstVerified && (
      <div className="gst-input-section">
        <div className="input-group">
          <label>GST Number</label>
          <input
            type="text"
            value={verificationData.gstNumber}
            onChange={(e) => setVerificationData(prev => ({
              ...prev,
              gstNumber: e.target.value
            }))}
            placeholder="Enter GST Number"
            className="edit-input"
          />
        </div>
        
        <div className="input-group">
          <label>Upload GST Document</label>
          <div className="upload-container">
            <Button
              icon="pi pi-upload"
              label={verificationData.gstDocument ? "Change Document" : "Upload Document"}
              className="p-button-sm"
              onClick={async () => {
                try {
                  const file = await pickFile();
                  const uploadedId = await uploadImage(file);
                  setVerificationData(prev => ({
                    ...prev,
                    gstDocument: uploadedId
                  }));
                  setIsAnyChanges(true);
                } catch (error) {
                  console.error("Failed to upload GST document:", error);
                }
              }}
            />
            {verificationData.gstDocument && (
              <div className="document-preview">
                <i className="pi pi-file-pdf" style={{ marginRight: '8px' }}></i>
                <span>Document uploaded</span>
                <Button
                  icon="pi pi-times"
                  className="p-button-text p-button-sm"
                  onClick={() => setVerificationData(prev => ({
                    ...prev,
                    gstDocument: null
                  }))}
                />
              </div>
            )}
          </div>
        </div>
        
        {/* Submit GST Info Button */}
        <div className="submit-gst-section">
          <Button
            label="Submit GST Information"
            icon="pi pi-check"
            className="p-button-sm p-button-success"
            disabled={!verificationData.gstNumber || !verificationData.gstDocument}
            onClick={async () => {
              try {
                // TODO: Add API call to submit GST info
                // await submitGSTInfo({
                //   gstNumber: verificationData.gstNumber,
                //   documentId: verificationData.gstDocument
                // });
                
                toast.current?.show({
                  severity: "success",
                  summary: "Submitted",
                  detail: "GST information submitted for verification",
                  life: 3000
                });
                
                // Update verification status
                setVerificationData(prev => ({
                  ...prev,
                  gstSubmitted: true
                }));
                
              } catch (error) {
                toast.current?.show({
                  severity: "error",
                  summary: "Error",
                  detail: "Failed to submit GST information",
                  life: 3000
                });
              }
            }}
          />
        </div>
      </div>
    )}
    
    {/* Show GST number if verified */}
    {!isEditing && profileData?.isGstVerified && (
      <div className="verified-gst-info">
        <div className="info-item">
          <i className="pi pi-check-circle verified-icon"></i>
          <span>GST Number: <strong>**********</strong></span>
        </div>
        <p className="verification-note">Your GST has been verified by our team.</p>
      </div>
    )}
    
    {/* Show pending GST submission */}
    {!isEditing && !profileData?.isGstVerified && verificationData.gstSubmitted && (
      <div className="pending-gst-info">
        <div className="info-item">
          <i className="pi pi-clock pending-icon"></i>
          <span>GST verification is pending</span>
        </div>
        <p className="verification-note">Our team will verify your documents shortly.</p>
      </div>
    )}
  </div>
</div>
    </div>
  );
};

export default ManageProfileTabContent;
